var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66683C11.6667 4.82516 10.175 3.3335 8.33333 3.3335C6.49167 3.3335 5 4.82516 5 6.66683C5 8.5085 6.49167 10.0002 8.33333 10.0002C10.175 10.0002 11.6667 8.5085 11.6667 6.66683ZM10 6.66683C10 7.5835 9.25 8.3335 8.33333 8.3335C7.41667 8.3335 6.66667 7.5835 6.66667 6.66683C6.66667 5.75016 7.41667 5.00016 8.33333 5.00016C9.25 5.00016 10 5.75016 10 6.66683Z",
    fill: "#162942",
    fillOpacity: 0.59
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 15.0003V16.667H14.9993V15.0003C14.9993 12.7837 10.5577 11.667 8.33268 11.667C6.10768 11.667 1.66602 12.7837 1.66602 15.0003ZM3.33268 15.0003C3.49935 14.4087 6.08268 13.3337 8.33268 13.3337C10.5743 13.3337 13.141 14.4003 13.3327 15.0003H3.33268Z",
    fill: "#162942",
    fillOpacity: 0.59
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.166 8.3335H14.166V10.0002H19.166V8.3335Z",
    fill: "#162942",
    fillOpacity: 0.59
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Person.a8b5232b.svg";
export { ForwardRef as ReactComponent };